import React, { Component, useContext } from 'react';
import ReactDOM from 'react-dom';
import furioosSdk, { Player } from 'furioos-sdk';
import firebase from '../../lib/firebase.prod';

const project_code = 'townville';

class CallFurioos extends Component {
	player;

	startFurioos(
		user_email,
		user_name,
		user_phone,
		user_avatar,
		user_time,
		img_file,
		user_type,
		appointmentId,
		user_id,
		callBack,
		iFrameName,
		furId
	) {
		const options = {
			whiteLabel: true,
			hideToolbar: true,
			hideTitle: true,
			hidePlayButton: false,
		};

		var FinishFurioosCallBack = callBack;

		var userEmail = user_email;
		var userFullName = user_name;
		var userPhoneNumber = user_phone;
		var userAvatarCode = user_avatar;
		var userAppointmentTimeUnix = user_time;
		var imageFile = img_file;
		var thisUserType = user_type;
		var thisAppointmentId = appointmentId;
		var thisUserId = user_id;

		console.log('The time is : ' + userAppointmentTimeUnix);

		console.log('furios id ' + furId + ' iframe name ' + iFrameName);
		this.player = new Player(String(furId), iFrameName, options);

		var self = this;

		this.player.onLoad(function () {
			// Here you know when the player is ready.
			console.log('PLAYER LOADED');

			//self.player.start();
			try {
				console.log('PLAYER LOADED once');
				self.player.start();

				//player.setQuality("AUTO");
				// var loadScreen = document.getElementById("loadingScreen");
				// var loadingGif = document.getElementById("loadingGifImg");

				// loadingGif.remove();
				// loadScreen.remove();

				// ReactDOM.unmountComponentAtNode(document.getElementById('rootCam'));
			} catch (err) {
				console.log(err + ' weird bug');
			}
		});

		this.player.onUserActive(function () {
			// Implement your own code.
			console.log('My user is active');
			//player.setQuality(Player.qualityValues.AUTO);
			//here we then need to implement passing data
		});

		this.player.onUserInactive(function () {
			// Implement your own code.
			console.log('My user is inactive');
		});

		this.player.onSessionStopped(function () {
			// Implement your own code.
			console.log('The session has been stopped');
			FinishFurioosCallBack();
		});

		this.player.onSDKMessage(function (data) {
			console.log('Message received from my application: ', data);

			console.log(data.unityReady);

			var dataRemovedBracket = data.replace('}', '');
			dataRemovedBracket = dataRemovedBracket.replace('{', '');

			console.log('Data removed bracket = ' + dataRemovedBracket);
			// {unityReady:true}
			var splitMessage = dataRemovedBracket.split(':');
			var dataString0 = splitMessage[0];

			//Get user info
			if (dataString0 === 'unityReady') {
				if (splitMessage[1] === 'true') {
					//player.maximize();
					//for image file
					// console.log(imageFile);
					//var thisBody = {test:"test"};

					console.log('user time: ' + userAppointmentTimeUnix);
					var thisBody = {
						userInfo: {
							email: userEmail,
							name: userFullName,
							phoneNumber: userPhoneNumber,
							avatarCode: userAvatarCode,
							userAppointmentTime: userAppointmentTimeUnix,
							userType: thisUserType,
							appId: thisAppointmentId,
							userId: thisUserId,
							image: imageFile,
						},
					};
					console.log('BODY BEING SENT ' + JSON.stringify(thisBody));
					//var thisBody = {userInfo:{email: userEmail, name: userFullName, phoneNumber: userPhoneNumber, avatarCode: userAvatarCode, userAppointmentTime: userAppointmentTimeUnix, image: imageFile, userType: thisUserType, appId: thisAppointmentId, userId: thisUserId}};
					try {
						self.player.sendSDKMessage(thisBody);
					} catch (err) {
						console.log(
							'seems we get multiple players alive but they should be gone? ' +
								err
						);
					}
				}
			}

			if (dataString0 === 'avatarCreatedCode') {
				if (splitMessage[1]) {
					userAvatarCode = splitMessage[1];

					console.log('GOT USER AVATAR ' + userAvatarCode);

					var currentUser = firebase.auth().currentUser;
					var thisUid = currentUser.uid;

					var userPostRef = firebase
						.database()
						.ref('/users/' + thisUid + '/avatarCode');

					userPostRef.set(userAvatarCode);
				}
			}
			//my build
			if (dataString0.includes('unit') && !dataString0.includes('unity')) {
				var removedRooms = dataRemovedBracket.replace('"rooms":[', '');
				var splitComma = removedRooms.split(',');

				createHtmlFromArray(splitComma);
				// var emailGuestPost4 = app.database().ref('/myBuildEmails/' + project_code).push();

				// emailGuestPost4.set({
				//     email: userEmail,
				//     build: "EMAIL STUFF"
				// });
			}

			//ShutDown
			//Get user info
			if (dataString0.includes('endSession')) {
				if (splitMessage[2].includes('True')) {
					try {
						self.player.stop();
					} catch (err) {
						console.log(
							'seems we get multiple players alive but they should be gone? ' +
								err
						);
					}
					//FinishFurioosCallBack();
				} else if (splitMessage[2].includes('False')) {
					try {
						self.player.stop();
					} catch (err) {
						console.log(
							'seems we get multiple p[layers alive but they should be gone? ' +
								err
						);
					}
				}
			}

			//ExtendTime
			if (dataString0 === 'extendedSession') {
				UseAnotherAppointment();
			}
		});

		var createHtmlFromArray = (arrayForEmail) => {
			var thisHtml =
				'<div style=" margin:auto; text-align: center; vertical-align: middle; width: 65%;">';
			arrayForEmail.forEach((element) => {
				console.log('split comma = ' + element);
				// thisLineToAdd is the html for this element
				var thisLineToAdd = '';
				if (element.includes('unit')) {
					//this means this is our title
					var splitAgent = element.split(':');
					var removedQuote = splitAgent[1].replace(/"/g, '');

					thisLineToAdd = '<h1>MY BUILD - ' + removedQuote + '</h1>';

					thisHtml = thisHtml + thisLineToAdd;
				}

				if (element.includes('room')) {
					//this means this is our title
					var splitAgent = element.split(':');
					var removedQuote = splitAgent[1].replace(/"/g, '');

					thisLineToAdd = '<hr><h3>' + removedQuote + '</h3>';

					thisHtml = thisHtml + thisLineToAdd;
				}

				if (element.includes('lines')) {
					//this is for our current room
					var splitAgent = element.split(':');
					var removedQuote = splitAgent[2].replace(/"/g, '');

					thisLineToAdd = '<p>' + removedQuote;

					thisHtml = thisHtml + thisLineToAdd;
				} else if (element.includes('name')) {
					//this is for our current room
					var splitAgent = element.split(':');
					var removedQuote = splitAgent[1].replace(/"/g, '');

					thisLineToAdd = '<p>' + removedQuote;

					thisHtml = thisHtml + thisLineToAdd;
				}

				if (element.includes('price')) {
					//this means this is our title
					var splitAgent = element.split(':');
					var removedQuote = splitAgent[1].replace(/"/g, '');

					if (removedQuote.includes('}]}]}')) {
						removedQuote = removedQuote.replace('}]}]}', '');
					} else if (removedQuote.includes('}]}')) {
						removedQuote = removedQuote.replace('}]}', '');
					}

					thisLineToAdd = ': $' + removedQuote + '<p>';

					thisHtml = thisHtml + thisLineToAdd;
				}
			});

			var emailBuild = firebase
				.database()
				.ref('/myBuildEmails/' + project_code)
				.push();

			emailBuild.set({
				email: userEmail,
				build: thisHtml,
			});

			thisHtml = thisHtml + '</div>';
			console.log('Finished Html: ' + thisHtml);
		};

		var UseAnotherAppointment = () => {
			console.log('EXTENDING SESSION');
			var d = new Date();
			var months = [
				'January',
				'February',
				'March',
				'April',
				'May',
				'June',
				'July',
				'August',
				'September',
				'October',
				'November',
				'December',
			];
			var thisMonth = months[d.getMonth()];
			var thisYear = d.getFullYear();
			var yearString = thisYear.toString();

			firebase
				.database()
				.ref('/kavtek_clients/' + project_code)
				.once('value', (snapshot) => {
					if (snapshot.hasChild(yearString + thisMonth)) {
						var totalAppUsed = snapshot.child(yearString + thisMonth).val();

						var totalAppsUsedRef = firebase
							.database()
							.ref(
								'/kavtek_clients/' + project_code + '/' + yearString + thisMonth
							);

						var newTotal = totalAppUsed + 1;

						totalAppsUsedRef.set(newTotal);
						console.log('SESSION SHOULD OF BEEN EXTENDED');
					} else {
						var totalAppsUsedRef = firebase
							.database()
							.ref(
								'/kavtek_clients/' + project_code + '/' + yearString + thisMonth
							);
						var totalAppUsed = 1;
						totalAppsUsedRef.set(totalAppUsed);
						console.log('SESSION SHOULD OF BEEN EXTENDED');
					}
				});
		};
	}

	stopPresentation() {
		console.log('presentation stopping furioos stopping');
		this.player.stop();
	}
}

export default CallFurioos;
